import { render, staticRenderFns } from "./ChangeAnchorPanel.vue?vue&type=template&id=1fd71bd4&scoped=true&"
import script from "./ChangeAnchorPanel.vue?vue&type=script&lang=js&"
export * from "./ChangeAnchorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd71bd4",
  null
  
)

export default component.exports